export default {
    CAMERA: 'Camera',
    LOCATION: 'Location',
    CAMERA_ROLL: 'CameraRoll',
};
